<template>
    <div class="course-banner mb-6">
        <div class="px-6 py-4">
            <div class="d-flex justify-space-between mb-2">
                <small>{{ `Del ${startDate} al ${endDate}` }}</small>
                <div class="d-flex flex-column align-end">
                    <small v-if="totalDiscountPercent > 0" class="course-banner-original-price">{{ course.amount | $currency }}</small>
                    <span class="font-weight-bold">{{ course.amount * (1 - totalDiscountPercent / 100) | $currency }}</span>
                </div>
            </div>
            <div class="font-weight-black mb-3" style="line-height: 1.2;">
                {{ course.courseName || course.billingProductName || 'Curso' }}
            </div>
            <div class="course-banner-desc">
                <span>{{ course.subdescription }}</span>
                <span class="d-block font-weight-bold mt-2">¡Inscribite y recibí tu certificado oficial para sumar al CV!</span>
            </div>
            <div class="my-2">
                <v-btn color="secondary" rounded @click="setCourse">Inscribirme</v-btn>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import { $course } from '../Services/'
import { mapGetters } from 'vuex'

export default {
    name: 'CourseItem',
    props: {
        course: { type: Object, required: true },
    },
    data() {
        return {
            //
        }
    },
    computed: {
        ...mapGetters({
            studentCareerId: 'commons/getStudentActualRegister',
        }),
        startDate() {
            return this.course.classStart ? moment(this.course.classStart).format('DD/MM') : ''
        },
        endDate() {
            return this.course.classEnd ? moment(this.course.classEnd).format('DD/MM') : ''
        },
        totalDiscountPercent() {
            const discount = this.course.discount?.percentage || 0;
            const scholarship = this.course.scholarship?.percentage || 0;
            return Math.min(discount + scholarship, 100);
        },
    },
    methods: {
        async setCourse() {
            try {
                const discountPercent = this.course.discount?.percentage || 0;
                const scholarshipPercent = this.course.scholarship?.percentage || 0;

                const discount = this.course.discount
                    ? {
                        ...this.course.discount,
                        amount: this.$encrypter(Math.round(this.course.amount * (discountPercent / 100))),
                        percentage: this.$encrypter(discountPercent)
                    }
                    : null;

                const scholarship = this.course.scholarship
                    ? {
                        ...this.course.scholarship,
                        amount: this.$encrypter(Math.round(this.course.amount * (scholarshipPercent / 100))),
                        percentage: this.$encrypter(scholarshipPercent)
                    }
                    : null;

                await $course.create({ discount, scholarship }, { params: { studentCareerId: this.studentCareerId, courseId: this.course.courseId }}, 'generateAccountCourse')

                this.$trackEvent('Home', 'Clk_ BtnBnrInscribirCursoIA_CargAcadm', 'Inscription_Course')
                this.$router.push({ path: '/payments', query: { courseRedirect: true } });
            } catch (error) {
                this.$store.dispatch('commons/openPopUp', {
                    title: this.$t('actions.error'),
                    content: [{ value: this.$t('Ocurrió un error. Intente nuevamente más tarde.') }],
                    actionPrimary: { text: this.$t('actions.accept'), callback() {} },
                    icon: { color: 'error', name: 'mdi-close' },
                    color: 'primary',
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');

.course-banner {
    background: url('~@/assets/images/portalalumno/IABanner.png') no-repeat right center;
    background-size: cover;
    border-radius: 16px;
    color: #fff;
    font-family: 'Poppins', sans-serif;
    font-size: 20px;

    .course-banner-original-price {
        text-decoration: line-through;
        line-height: 1;
        opacity: 0.7;
    }

    .course-banner-desc {
        margin-bottom: 1rem;
        line-height: 1.3;
        font-size: 16px;

        @media (min-width: 720px) { width: 80%; }
    }
}

</style>
